import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { HeroV2 } from "@/components/HeroV2";
import { Marquee } from "@/components/Marquee";
import { Experience } from "@/components/Experience";
import { Highlights } from "@/components/Highlights";
import { PerformersV2 } from "@/components/PerformersV2";
import { EventDetails } from "@/components/EventDetails";
import { TicketsV2 } from "@/components/TicketsV2";
import { Venue } from "@/components/Venue";
import { SocialSection } from "@/components/SocialSection";
import { ShareSection } from "@/components/ShareSection";
import { Faq } from "@/components/Faq";
import { FinalCta } from "@/components/FinalCta";
import { Footer } from "@/components/Footer";
import { StickyCta } from "@/components/StickyCta";
import { initScrollTracking } from "@/lib/analytics";
import { initLenis } from "@/lib/scroll";

// ============================================================================
// PREVIEW LANDING — the "next level" redesign, live at /preview.
// ----------------------------------------------------------------------------
// This does NOT touch the "/" route or any component the live site uses.
// It reuses every section that was already working well (Marquee, Experience,
// Highlights, EventDetails, Venue, SocialSection, ShareSection, Faq, FinalCta,
// Footer, StickyCta, Navbar) exactly as-is, and swaps in three elevated
// components — HeroV2, PerformersV2, TicketsV2 — for the three surfaces with
// the most room to feel more premium: the first impression, the artist
// story, and the ticket moment.
//
// To preview: run the site locally (yarn start) and open /preview.
// To go live with this design: once approved, this file's contents replace
// the <main> of Landing() in App.js (or Landing() is pointed at these V2
// components directly) — a decision left for you to make, not made here.
// ============================================================================

export default function PreviewLanding() {
  useEffect(() => {
    initLenis();
    return initScrollTracking();
  }, []);

  return (
    <div className="min-h-screen bg-[#080705] text-[#F7F4EF] antialiased">
      <a
        href="#experience"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[80] focus:rounded-full focus:bg-[#D4AF37] focus:px-6 focus:py-3 focus:text-sm focus:font-bold focus:text-[#080705]"
      >
        Skip to content
      </a>
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <HeroV2 />
        <Marquee />
        <Experience />
        <Highlights />
        <PerformersV2 />
        <EventDetails />
        <TicketsV2 />
        <Venue />
        <SocialSection />
        <ShareSection />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <StickyCta />
    </div>
  );
}
